import Element from '../../Element';
import Renderable from '../../../../Component/Renderable';
import UIScrollComponent from '../../../../Component/UI/Scroll';

export default class FriendHubScroll extends Element {
    public create(params: any): void {
        super.create({
            type: 'group',
            name: 'friend_hub_scroll',
            layout: {
                anchors: [0.5, 0.5, 0.5, 0.5],
                pivot: [0.5, 0.5],
                offsets: [0, 0, 0, 0],
                ...params.layout,
            },
            components: [
                {
                    type: 'scroll',
                    data: {
                        friction: 0.9,
                        direction: 'y',
                    },
                },
                {
                    type: 'mask',
                    data: {
                        offset: [0, 0, 0, 0],
                    },
                },
            ],
            ...params,
        });
        const scroll: UIScrollComponent = this.getComponent(UIScrollComponent);

        scroll.direction = 'y';
        scroll.friction = 0.9;

        this.addComponent(Renderable);
    }
}
